module.exports = __webpack_public_path__ + "aw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/aw.svg
// module id = 685
// module chunks = 0